import { render } from "./SlackPreview.vue?vue&type=template&id=22655f08&scoped=true"
import script from "./SlackPreview.vue?vue&type=script&lang=js"
export * from "./SlackPreview.vue?vue&type=script&lang=js"

import "./SlackPreview.vue?vue&type=style&index=0&id=22655f08&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22655f08"]])

export default __exports__